module.exports = __webpack_public_path__ + "static/media/80.46550680.jpg";